import React, { useEffect } from "react";
// react-bootstrap components
import { Auth } from "aws-amplify";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  RiCloseLine,
  RiMailCheckLine,
  RiUserFollowLine,
  RiUserUnfollowLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { invokeLambdaWithRetry, isEmailChar } from "services/Helper";
import MeaBannerIcon from "../../newui/assets/images/login_mea_banner.svg";
import MeaIcon from "../../newui/assets/images/Mea-Logo 1.svg";
import "../assets/css/style.css";
import logo from "../assets/images/logo.png";
import "../assets/vendors/base/vendor.bundle.base.css";
import "../assets/vendors/ti-icons/css/themify-icons.css";
import CirclesLoader from "../layouts/CirclesLoader";
import { createUiLogger } from "../../logging/uiLogger";
const console = createUiLogger("meaplatform/classic/layouts/MicrosoftAuthLayout.js");



function MicrosoftAuth() {
  let [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [showModalMsg, setShowModalMsg] = React.useState("");
  const navigate = useNavigate();
  let [email, setEmail] = useState("");
  const [msAuthConfirmationModal, setMsAuthConfirmationModal] = useState(false);
  const [redirectStatus, setRedirectStatus] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const allowEmailChars = (e) => {
    if (isEmailChar(e.key) === false) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  useEffect(() => {
    let checkMsUser = localStorage.getItem("msUser");
    setEmail(checkMsUser || "");
  }, []);

  const validateUser = async (email) => {
    setLoading(true);
    try {
      localStorage.setItem("msUser", email);
      const body = {
        target: "fetchUserVault",
        UserId: email,
        microsoft: true,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      let chkLastAccess = data?.response?.lastAccessedOn;
      localStorage.setItem("lastAccessed", chkLastAccess);
      return { status: data.statusCode === 200, result: data };
    } catch (err) {
      console.error("err: ", err);
      return { status: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  const createUserVault = async () => {
    setLoading(true);
    try {
      const body = {
        target: "newUserVault",
        UserId: email,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      if (data?.statusCode === 200) {
        setShowModal(true);
        setShowModalMsg(
          <>
            <p>Thank you for registering</p>
            <p>
              Once approved you will receive an invitation to access mea
              platform
            </p>
            <p>Expect approval in less than one hour</p>
          </>
        );
        setRedirectStatus(true);
      }
      return data;
    } catch (err) {
      console.error("err: ", err);
      return { status: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  let validateMicrosoftAuth = async () => {
    console.debug("[MicrosoftAuth] submit", { email });
    const validationResult = await validateUser(email);
    console.debug("[MicrosoftAuth] validateUser result", {
      status: validationResult?.status,
      response: validationResult?.result?.response,
    });
    if (
      validationResult?.status &&
      Object.entries(validationResult?.result?.response).length === 0
    ) {
      await createUserVault();
    } else if (
      validationResult?.status &&
      Object.entries(validationResult?.result?.response).length > 0
    ) {
      const { Active, groups, user_sub } =
        validationResult?.result?.response ?? {};
      if (
        user_sub === "inactive" &&
        (Active === 0 || groups === "MEA_PENDINGUSERS")
      ) {
        setShowModal(true);
        setShowModalMsg(
          <>
            <p>Your registration is pending approval</p>
            <p>
              Once approved you will receive an invitation to access mea
              platform
            </p>
            <p>Expect approval in less than one hour</p>
          </>
        );
        setRedirectStatus(false);
      } else if (user_sub && Active === 0) {
        setShowModal(true);
        setShowModalMsg(
          <>
            <p>Your registration is pending approval</p>
            <p>
              Once approved you will receive an invitation to access mea
              platform
            </p>
            <p>Expect approval in less than one hour</p>
          </>
        );
        setRedirectStatus(false);
      } else if (
        (Active !== 0 &&
          groups !== "MEA_PENDINGUSERS" &&
          user_sub !== null &&
          user_sub?.startsWith("invite-")) ||
        user_sub === null
      ) {
        setMsAuthConfirmationModal(true);
      } else if (
        Active === 1 &&
        groups !== "MEA_PENDINGUSERS" &&
        user_sub !== null &&
        !user_sub?.startsWith("invite-")
      ) {
        console.debug("[MicrosoftAuth] calling federatedSignIn", {
          user_sub,
          Active,
          groups,
        });
        Auth.federatedSignIn({ provider: "AzureADOpen" })
          .then((result) => {
            console.info("[MicrosoftAuth] federatedSignIn success", result);
          })
          .catch((e) => {
            console.error("[MicrosoftAuth] federatedSignIn error", e);
          });
      } else {
        console.debug("[MicrosoftAuth] no matching auth branch", {
          Active,
          groups,
          user_sub,
        });
      }
    }
  };

  const reinviteUser = async () => {
    let checkMsUser = localStorage.getItem("msUser");
    setLoading(true);
    try {
      const body = {
        target: "reinviteuser",
        UserId: checkMsUser,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      setMsAuthConfirmationModal(false);
      return data;
    } catch (err) {
      console.error("err: ", err);
      return { status: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  const redirectToLogin = (e) => {
    let path = `/login`;
    navigate(path);
  };

  return (
    <>
      <div className="authlayout-container p-3">
        <div className="h-100 authform-container flex">
          <div className="meaicon-banner p-2 flex-center">
            <div className="w-100">
              <img src={MeaBannerIcon} alt="MeaBannerIcon" className="w-100" />
            </div>
          </div>

          <div className="flex authlogo-formcontainer">
            <div className="w-55 flex-colcenter">
              <div>
                <div className="flex-center mb-3">
                  <div className="auth-mealogo-texticon">
                    <img src={logo} alt="MeaIconText" className="w-100" />
                  </div>
                </div>
                <div className="w-100">
                  <div className="flex-center">
                    <h1 className="authform-measlogan-text">make your life</h1>
                  </div>
                  <div className="flex-center">
                    <h1 className="authform-measlogan-text">easier</h1>
                  </div>
                </div>
              </div>
              <p className="authform-limitedyear">
                mea platform limited {new Date().getFullYear()}.
              </p>
            </div>
            <div className="authform-layoutcontainer flex-colcenter">
              <div className="authform-fieldcontainer">
                <div className="mb-4 mt-4 authform-mealogo-container">
                  <img
                    src={MeaIcon}
                    alt="MEA-ICON"
                    className="authform-mealogoicon"
                  />
                </div>
                <h1 className="formcontainer-title text-center">
                  Email Address Authentication
                </h1>
                <h5 className="text-center authform-subtitle  mt-1 mb-1">
                  Enter your valid microsoft email id
                </h5>
                <div className="p-3 login-form">
                  <form className="pt-3">
                    <div className="form-group">
                      <label className="login-formlabel text-left">
                        Email address
                      </label>
                      <div className="input-group">
                        <input
                          type="email"
                          className="formcontainer-inputfield"
                          value={email}
                          pattern="[A-Za-z0-9]+"
                          onKeyDown={allowEmailChars}
                          onFocus={() => setShowTooltip(true)} 
                          onChange={(event) => {
                            setEmail(event.target.value);
                          }}
                          onBlur={() => {
                            setShowTooltip(false);
                          }}
                        />
                        {showTooltip && (
                          <div className="email-tooltip">
                            <div className="tooltip-arrow" />
                            Please use your business email address to register
                            with mea platform
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mt-4 my-3 row mx-0 justify-content-center">
                      <button
                        type="button"
                        className="formfields-button mt-2 authenticate-btn mb-3"
                        disabled={
                          !(
                            /^[^\s@]+@[^\s@]+$/.test(email) &&
                            !/meaplatform\.com$/i.test(email)
                          )
                        }
                        onClick={validateMicrosoftAuth}
                      >
                        Submit
                      </button>
                          <button
                          type="Submit"
                          className="formfields-button authenticate-btn"
                          onClick={(e)=>redirectToLogin(e)}
                        >
                          Cancel
                        </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="flex-center">
                <p className="login-footertitle login-div-footer-title">
                  read mea
                  <a
                    className="login-form-footer-text font-Poppins mr-1 ml-1"
                    href="https://www.meaplatform.com/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    privacy policies
                  </a>
                  and
                  <a
                    className="login-form-footer-text font-Poppins mr-1 ml-1"
                    href="https://www.meaplatform.com/terms/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    terms and conditions
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* loader Modal */}
      <Modal
        className="modal-centre new-modal"
        backdrop="static"
        keyboard={false}
        show={loading}
        animation={false}
        centered
      >
        <Modal.Body className="text-center">
          <CirclesLoader isLoading={loading} />
        </Modal.Body>
      </Modal>
      {/* loader Modal */}

      {/* Mini Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
        centered={true}
        className="d-flex new-modal"
      >
        <Modal.Header className="justify-content-end pt-2">
          <button className="closeicon" onClick={() => setShowModal(false)}>
            <RiCloseLine />
          </button>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-3 px-3">
          {redirectStatus && (
            <p className="identiy-icons">
              <RiUserFollowLine />
            </p>
          )}
          {!redirectStatus && (
            <p className="identiy-icons">
              <RiUserUnfollowLine />
            </p>
          )}
          <div className="mt-3 mb-2 text-center modal-msg">{showModalMsg}</div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center pb-0">
          <p>
            powered by <span>mea platform</span>
          </p>
        </Modal.Footer>
      </Modal>
      {/* End Modal */}

      {/* Mini Modal */}
      <Modal
        className="modal-md modal-primary new-modal"
        show={msAuthConfirmationModal}
        onHide={() => setMsAuthConfirmationModal(false)}
        backdrop="static"
        animation={false}
        backdropClassName="question-modal"
        centered={true}
      >
        <Modal.Header className="justify-content-end pt-3">
          <button
            className="closeicon"
            onClick={(e) => {
              setMsAuthConfirmationModal(false);
              redirectToLogin(e);
            }}
          >
            <RiCloseLine />
          </button>
        </Modal.Header>
        <Modal.Body className="text-center pt-0 pb-3 px-3">
          <p className="identiy-icons">
            <RiMailCheckLine />
          </p>
          <p className="text-center mb-1">
            An invitation to access mea platform has been sent to your email
            address
          </p>
          <p className="mb-1">Would you like to regenerate the invite?</p>
          <button
            type="button"
            className="btn btn-secondary btn-md font-weight-medium mt-3 mb-2"
            onClick={() => {
              reinviteUser();
            }}
          >
            Yes
          </button>
        </Modal.Body>
        <Modal.Footer className="justify-content-center pb-0">
          <p>
            powered by <span>mea platform</span>
          </p>
        </Modal.Footer>
      </Modal>
      {/* End Modal */}
    </>
  );
}

export default MicrosoftAuth;
